


























































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Pagination } from '@/domain/entities/Pagination'
@Component({
  name: 'pagination',
  props: {
    paginationData: {
      type: Pagination,
    },
    funcFirstPage: {
      type: Function,
    },
    funcPrevPage: {
      type: Function,
    },
    funcNextPage: {
      type: Function,
    },
    funcLastPage: {
      type: Function,
    },
    onShowPageNumChanged: {
      type: Function,
    },
    optionsPerPage: {
      type: Array,
      default() {
        return [
          { value: 10, text: 'Show: 10' },
          { value: 15, text: 'Show: 15' },
          { value: 20, text: 'Show: 20' },
        ]
      },
    },
  },
})
export default class extends Vue {}
